import { Instagram } from "lucide-react";
import { Eyebrow, Reveal } from "./Reveal";

const STEPS = [
  ["Escolha", "Selecione o serviço ou a versão do Pack Gospel que você precisa."],
  ["Pague via Pix", "Copie a chave Pix (CNPJ) e pague no app do seu banco."],
  ["Comprovante & entrega", "Envie o comprovante e o briefing pelo WhatsApp — o atendimento e a entrega acontecem por lá."],
];

export const About = ({ settings }) => (
  <section id="sobre" className="relative bg-[#071D1F] py-24 md:py-36" data-testid="about-section">
    <div className="mx-auto grid max-w-[1400px] gap-16 px-5 md:px-10 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <Eyebrow n="04">Sobre</Eyebrow>
        <Reveal>
          <h2 className="font-display mt-6 text-4xl font-semibold uppercase leading-[0.95] text-teal-50 md:text-6xl">
            Por trás de cada arte, <span className="font-serif-i normal-case text-[#2DD4BF]">Samuel Soares.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-8 max-w-lg text-base leading-relaxed text-teal-100/85 md:text-lg">
            Designer e responsável pela agência S'Designer. Criação de peças gráficas para igrejas, eventos, artistas e marcas — e packs editáveis para quem também vive de design.
          </p>
          <a href={`https://instagram.com/${settings?.instagram || "sdesigner.ag"}`} target="_blank" rel="noreferrer" data-testid="about-instagram-link" className="mt-8 inline-flex items-center gap-2 text-[#2DD4BF] underline-offset-4 hover:underline">
            <Instagram className="h-5 w-5" /> @{settings?.instagram || "sdesigner.ag"}
          </a>
        </Reveal>
      </div>
      <div className="lg:col-span-6">
        <p className="font-mono-x mb-6 text-xs uppercase tracking-[0.22em] text-teal-300">Como funciona</p>
        {STEPS.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.1}>
            <div className="flex gap-6 border-t border-[#163D43] py-7" data-testid={`process-step-${i}`}>
              <span className="font-display text-5xl font-semibold text-outline">{i + 1}</span>
              <div>
                <h3 className="font-display text-2xl font-semibold text-teal-50">{t}</h3>
                <p className="mt-2 text-teal-200/90">{d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
